import {ErrorPageTemplate} from './page'
import * as React from 'react'

export class NotFoundError extends React.PureComponent<{}> {
  public render() {
    return (
      <ErrorPageTemplate errorCode="404" errorMessage="We can't find the page you're looking for" />
    )
  }
}
